export default {
  id: undefined,
  type: 'service_add_on',
  attributes: {
    name: 'Add On',
    description: '',
    amount: 0,
    duration: 0,
    priority: 0,
    service_id: null,
  },
}
